import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Home.css';

/* ---------- Icons ---------- */
const CodeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
  </svg>
);
const PenIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </svg>
);
const BrandIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
  </svg>
);
const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);
const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);
const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const LocationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const MailIcon2 = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const ShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);
const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37a4 4 0 11-2.63-3.74 4 4 0 012.63 3.74z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const GithubIcon2 = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
  </svg>
);
const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

const techStack = ['React', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Figma', 'Node.js', 'PostgreSQL', 'Three.js', 'Video Editing', 'SEO', 'Performance Optimization', 'E-commerce Solutions','React Native',];

import { usePortfolio } from '../context/PortfolioContext';

const CONTACT_EMAIL = 'talhakhaliddhariwal@gmail.com';

export default function Home() {
  const { data, loading: isDataLoading } = usePortfolio();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: 'Project Inquiry',
    message: '',
  });

  if (isDataLoading || !data) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-dark)', color: 'white' }}>Loading...</div>;
  }
  const { expertise, projects } = data;


  const handleContactChange = (event) => {
    const { name, value } = event.target;
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();

    setIsSubmitting(true);

    try {
      const response = await fetch(`https://formsubmit.co/ajax/${CONTACT_EMAIL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          name: contactForm.name,
          email: contactForm.email,
          subject: contactForm.subject,
          message: contactForm.message,
          _template: 'table',
        }),
      });

      const result = await response.json();

      if (result.success) {
        setContactForm({
          name: '',
          email: '',
          subject: 'Project Inquiry',
          message: '',
        });
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="home page-enter">
      <Navbar />

      {/* ===== HERO ===== */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-badge">✦ Available for new projects</span>
          <h1 className="hero-title">
            <span className="hero-title-sub">Hello I am</span> <br /><span className="purple">Talha Khalid</span> <br />
          </h1>
          <p className="hero-desc">
            Full-Stack Developer and Social Media Marketing Expert specializing in scalable web solutions and data-driven marketing strategies that elevate digital presence and drive brand growth.
          </p>
          <div className="contact-socials hero-socials">
            <a href="https://www.instagram.com/talha_._khalid" target="_blank" rel="noreferrer" className="social-ico"><InstagramIcon /></a>
            <a href="https://www.linkedin.com/in/talha-khalid-81ba97266/" target="_blank" rel="noreferrer" className="social-ico"><LinkedInIcon /></a>
            <a href="https://github.com/Talha-Khalid-D" target="_blank" rel="noreferrer" className="social-ico"><GithubIcon2 /></a>
          </div>
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => navigate('/projects')}>
              View Projects
            </button>
            <button className="btn-outline" onClick={() => navigate('/contact')}>
              Hire Me
            </button>
          </div>
        </div>
        <div className="hero-image-wrap">
          <div className="hero-image-bg" />
          <div className="hero-img-placeholder">
            <img className="hero-main-image" src="/images/hero-image.png" alt="Talha Khalid" />
          </div>
        </div>
      </section>

      {/* ===== ABOUT ME ===== */}
      <section className="about-strip">
        <div className="container">
          <div className="section-header">
            <h2>ABOUT ME</h2>
            <div className="section-divider" />
            <p className="about-subtitle">Welcome to Talha Developments – Your Destination for Development & Design Services.</p>
          </div>
          <p className="about-text">
            I have 2+ years of experience in designing and developing high-quality web solutions for clients across various industries. My expertise includes React, Next.js, TypeScript, Tailwind CSS, Figma, Node.js, PostgreSQL, Video Editing, SEO, Performance Optimization, E-commerce Solutions, and React Native.
          </p>
          <div className="tech-tags">
            {techStack.map(t => (
              <span key={t} className="tag">{t}</span>
            ))}
          </div>
        </div>
      </section>

      {/* ===== EXPERTISE ===== */}
      <section className="expertise-section">
        <div className="container">
          <h2 className="expertise-heading">My Expertise</h2>
          <p className="expertise-sub">Tailored solutions for modern business needs.</p>
          <div className="expertise-grid">
            {expertise.map(e => {
              let IconComp = <CodeIcon />;
              if (e.iconType === 'pen') IconComp = <PenIcon />;
              if (e.iconType === 'brand') IconComp = <BrandIcon />;
              if (e.iconType === 'trend') IconComp = <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M23 7l-7.5 7.5-4-4L1 21"/><path d="M17 7h6v6"/><rect x="3" y="3" width="7" height="5" rx="1"/></svg>;
              if (e.iconType === 'users') IconComp = <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>;
              return (
              <div key={e.title} className="expertise-card">
                <div className="expertise-icon">{IconComp}</div>
                <h3>{e.title}</h3>
                <div className="card-divider" />
                <p>{e.desc}</p>
              </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== LATEST PROJECTS ===== */}
      <section className="projects-section">
        <div className="container">
          <div className="projects-header">
            <div>
              <h2>Latest Projects</h2>
              <p>A collection of my favorite works.</p>
            </div>
            <button className="explore-all" onClick={() => navigate('/projects')}>
              Explore all <ArrowIcon />
            </button>
          </div>
          <div className="projects-grid">
            {projects.slice(0, 4).map(p => (
              <a
                key={p.id}
                href={p.link || '#'}
                target={p.link ? '_blank' : '_self'}
                rel="noreferrer"
                className="project-card"
                onClick={e => { if (!p.link) { e.preventDefault(); navigate('/projects'); } }}
              >
                <div className="project-thumb" style={p.image ? undefined : { background: p.gradient }}>
                  {p.image ? (
                    <img className="project-thumb-image" src={p.image} alt={`${p.title} preview`} />
                  ) : p.dark ? (
                    <div className="project-thumb-inner dark">
                      <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="rgba(0,0,0,0.15)" strokeWidth="1.5">
                        <rect x="3" y="3" width="18" height="18" rx="2"/>
                        <path d="M3 9h18M9 21V9"/>
                      </svg>
                    </div>
                  ) : (
                    <div className="project-thumb-inner">
                      <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.2">
                        <rect x="2" y="3" width="20" height="14" rx="2"/>
                        <line x1="8" y1="21" x2="16" y2="21"/>
                        <line x1="12" y1="17" x2="12" y2="21"/>
                        <polyline points="4 9 8 13 12 9 16 13 20 9"/>
                      </svg>
                    </div>
                  )}
                </div>
                <div className="project-info">
                  <div className="project-tags">
                    {p.tags.map(t => <span key={t} className="tag">{t}</span>)}
                  </div>
                  <h3>{p.title}</h3>
                  {p.link && <span className="project-link-hint">View Project →</span>}
                  {!p.link && <span className="project-link-hint add-link">+ Add project link</span>}
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* PRICING REMOVED */}

      {/* ===== CONTACT STRIP ===== */}
      <section className="contact-strip">
        <div className="container contact-strip-inner">
          <div className="contact-strip-left">
            <h2>Ready to bring your<br /><span className="purple">ideas to life?</span></h2>
            <p>Whether you have a specific project in mind or just want to say hi, my inbox is always open.</p>
            <div className="contact-info-links">
              <a href={`mailto:${CONTACT_EMAIL}`} className="contact-info-item">
                <MailIcon2 /> {CONTACT_EMAIL}
              </a>
              <span className="contact-info-item">
                <LocationIcon /> Sialkot, Pakistan
              </span>
            </div>
            <div className="contact-socials">
              <a href="https://www.instagram.com/talha_._khalid" target="_blank" rel="noreferrer" className="social-ico"><InstagramIcon /></a>
              <a href="https://github.com/Talha-Khalid-D" target="_blank" rel="noreferrer" className="social-ico">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/talha-khalid-81ba97266/" target="_blank" rel="noreferrer" className="social-ico">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          <form className="contact-strip-form" onSubmit={handleContactSubmit} noValidate>
            <div className="form-row">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Talha Khalid"
                  value={contactForm.name}
                  onChange={handleContactChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="talhakhalid@example.com"
                  value={contactForm.email}
                  onChange={handleContactChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label>Subject</label>
              <select
                name="subject"
                value={contactForm.subject}
                onChange={handleContactChange}
                required
              >
                <option value="Project Inquiry">Project Inquiry</option>
                <option value="Collaboration">Collaboration</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                placeholder="Tell me about your project..."
                rows={5}
                value={contactForm.message}
                onChange={handleContactChange}
                required
              />
            </div>
            <button type="submit" className="btn-primary send-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
